import { JSResourceForUserVisible } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

export const burnDownReportEntrypoint = createEntryPoint({
	root: JSResourceForUserVisible(
		() =>
			import(
				/* webpackChunkName: "async-next-gen-reports-burn-down-entrypoint" */ './src/index.tsx'
			),
	),
	getPreloadProps: () => ({}),
});
